import { Text } from '../Text'
import Label from './Label'
import { cn } from '@lib/cn'
import React, { FC } from 'react'

export type FieldControlProps = {
  label?: React.ReactNode | string
  assistiveText?: string
  errorMsg?: string
  isCheckbox?: boolean
  className?: string
}

export const FieldControl: FC<FieldControlProps> = ({
  label,
  assistiveText,
  errorMsg,
  children,
  isCheckbox = false,
  className,
  ...rest
}) => {
  return (
    <div className={cn('relative mb-6 pt-3', className)} {...rest}>
      {children}
      {label ? typeof label === 'string' && <Label hasError={!!errorMsg}>{label}</Label> : label}
      {assistiveText ? (
        <Text variant="fixed16" className="mt-[2px] text-shade-500">
          {assistiveText}
        </Text>
      ) : errorMsg ? (
        <Text
          variant="legend14"
          className={cn(
            'absolute top-[calc(100%+0.25rem)] text-rolexRed',
            isCheckbox && 'relative left-6 mb-4',
          )}
        >
          {errorMsg}
        </Text>
      ) : null}
    </div>
  )
}
